import { assert_array_not_empty, assert_type_enum, not_implemented } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { logw } from '@shared/utils/utils_logs';
import { FIELD_PRIMITIVE__base } from '../../_fields/_primitives/_base/FIELD_PRIMITIVE__base';
import { FIELD__list_lora } from '../../_fields/_primitives/list/FIELD__list_lora';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { FIELD__any__ml_asset } from '../../_fields/any/FIELD__any__ml_asset';
import { FIELD__ml_asset_control_net } from '../../_fields/ml_asset/guidance/FIELD__ml_asset_control_net';
import { FIELD__ml_asset_t2i_adapter } from '../../_fields/ml_asset/guidance/FIELD__ml_asset_t2i_adapter';
import { DTO_GRAPH__instance } from '../DTO_GRAPH__instance';

declare module '../DTO_GRAPH__instance' {
  interface DTO_GRAPH__instance {
    values_allowed__clear(): void;

    values_allowed__fill(): void;

    values_allowed__fill_async(): Promise<void>;

    /*
     *
     */

    values_ml_assets__fill(ml_assets: DTO__ml_asset[]): void;

    values_ml_assets__fill_lora(ml_assets: DTO__ml_asset[]): void;

    values_ml_assets__fill_control_net(ml_assets: DTO__ml_asset[]): void;

    values_ml_assets__fill_t2i_adapter(ml_assets: DTO__ml_asset[]): void;
  }
}

export function INIT_EXTENSION_DTO_GRAPH__instance_fields_values_allowed() {
  //do nothing
}

/**
 * Validate the graph. Checks that all edges have valid source and destination nodes.
 * @returns Array of error types, empty if validation passes.
 */
DTO_GRAPH__instance.prototype.values_allowed__clear = function (): void {
  //todo: keep or remove

  return;
  let fields = this.fields__get_by_type(FIELD_PRIMITIVE__base);

  for (const field of fields) delete field.values_allowed;
};

DTO_GRAPH__instance.prototype.values_allowed__fill = async function () {
  logw('values_allowed__fill not implemented');
};

DTO_GRAPH__instance.prototype.values_allowed__fill_async = async function () {
  not_implemented();
};

DTO_GRAPH__instance.prototype.values_ml_assets__fill = function (ml_assets: DTO__ml_asset[]) {
  let fields = this.fields__get_by_type(FIELD_PRIMITIVE__string_hash_ml_asset);
  fields = fields.filter(field => field.populate_enabled);
  fields = fields.filter(field => field.ml_asset_type != ENUM__ml_asset_type.LORA); //skip loras because we have dedicated method
  fields = fields.filter(field => field.ml_asset_type != ENUM__ml_asset_type.CONTROL_NET); //skip control_net because we have dedicated method
  fields = fields.filter(field => !field.meta.data__is_linked); //skip linked

  for (const field of fields) {
    field.values_allowed = FN_ML_ASSET__filter_ids_by_family_and_type(ml_assets, field.ml_asset_type, field.meta.node_family);

    field.value_range = field.value_range.filter((item: any) => field.values_allowed.includes(item));

    if (field.value_range.is_empty()) field.value_range = [...field.values_allowed];

    try_set_first_ml_asset_hash(field, ml_assets);
  }
};

function try_set_first_ml_asset_hash(field: FIELD_PRIMITIVE__string_hash_ml_asset, ml_assets: DTO__ml_asset[]) {
  if (!field.is_empty) return;

  let values_allowed = field.get_values_allowed();

  let value = ENUM__string_id_empty.HASH_SHA256;

  if (values_allowed.is_empty()) {
    if (!(field instanceof FIELD__any__ml_asset)) logw(`ml_asset hash_sha256 empty ${field.meta.node_family}:${field.ml_asset_type}`);
  } else if (field.ml_asset_type == ENUM__ml_asset_type.UNET) {
    let ml_assets_unet_all = ml_assets.filter(item => values_allowed.includes(item.hash_sha256));
    assert_array_not_empty(ml_assets_unet_all);

    let ml_assets_unet_non_inpaint = ml_assets_unet_all.filter(item => !item.config.get_unet_is_inpaint());

    //select non inpaint unet if can

    if (ml_assets_unet_non_inpaint.is_empty()) {
      value = values_allowed[0];
    } else {
      value = ml_assets_unet_non_inpaint[0].hash_sha256;
    }
  } else {
    value = values_allowed[0];
  }

  field.set_value(value);
}

DTO_GRAPH__instance.prototype.values_ml_assets__fill_lora = function (ml_assets: DTO__ml_asset[]) {
  let ml_assets_lora = ml_assets.filter(ml_asset => ml_asset.type == ENUM__ml_asset_type.LORA);

  let fields = this.fields__get_by_type(FIELD__list_lora);
  fields = fields.filter(field => field.items.is_empty()); //skip non empty
  fields = fields.filter(field => !field.meta.data__is_linked); //skip linked

  for (let field_list of fields) {
    let ml_assets_lora_with_target_family = ml_assets_lora.filter(ml_asset => ml_asset.family == field_list.meta.node_family);

    for (let ml_asset_lora of ml_assets_lora_with_target_family) {
      let field_item = field_list.create_item_new();

      field_item.model.ml_asset_type = ENUM__ml_asset_type.LORA;

      field_item.model.set_value(ml_asset_lora.hash_sha256);
      field_item.model.values_allowed = [ml_asset_lora.hash_sha256];
      field_item.model.value_range = [ml_asset_lora.hash_sha256];
    }
  }
};

DTO_GRAPH__instance.prototype.values_ml_assets__fill_control_net = function (ml_assets: DTO__ml_asset[]) {
  let ml_assets_all = ml_assets.filter(ml_asset => ml_asset.type == ENUM__ml_asset_type.CONTROL_NET);

  let fields = this.fields__get_by_type(FIELD__ml_asset_control_net);
  fields = fields.filter(field => !field.meta.data__is_linked); //skip linked

  for (let field of fields) {
    let ml_assets = ml_assets_all.filter(ml_asset => ml_asset.family == field.meta.node_family);
    ml_assets = ml_assets.filter(ml_asset => ml_asset.config.get_control_net_type() == field.type.get_value());

    let values_allowed = ml_assets.map(ml_asset => ml_asset.hash_sha256);
    field.model.values_allowed = values_allowed;

    /*
     * VALUE RANGE
     */

    let value_range = field.model.get_value_range().filter(value => values_allowed.includes(value));

    if (value_range.is_empty()) value_range = [...values_allowed];

    field.model.set_value_range(value_range);

    /*
     * VALUE
     */

    if (!values_allowed.includes(field.model.get_value())) {
      let value = values_allowed.is_empty() ? ENUM__string_id_empty.HASH_SHA256 : values_allowed[0];
      field.model.set_value(value);
    }
  }
};

DTO_GRAPH__instance.prototype.values_ml_assets__fill_t2i_adapter = function (ml_assets: DTO__ml_asset[]) {
  let ml_assets_all = ml_assets.filter(ml_asset => ml_asset.type == ENUM__ml_asset_type.T2I_ADAPTER);

  let fields = this.fields__get_by_type(FIELD__ml_asset_t2i_adapter);
  fields = fields.filter(field => !field.meta.data__is_linked); //skip linked

  for (let field of fields) {
    let ml_assets = ml_assets_all.filter(ml_asset => ml_asset.family == field.meta.node_family);
    ml_assets = ml_assets.filter(ml_asset => ml_asset.config.get_t2i_adapter_type() == field.type.get_value());

    let values_allowed = ml_assets.map(ml_asset => ml_asset.hash_sha256);
    field.model.values_allowed = values_allowed;

    /*
     * VALUE RANGE
     */

    let value_range = field.model.get_value_range().filter(value => values_allowed.includes(value));

    if (value_range.is_empty()) value_range = [...values_allowed];

    field.model.set_value_range(value_range);

    /*
     * VALUE
     */

    if (!values_allowed.includes(field.model.get_value())) {
      let value = values_allowed.is_empty() ? ENUM__string_id_empty.HASH_SHA256 : values_allowed[0];
      field.model.set_value(value);
    }
  }
};

function FN_ML_ASSET__filter_ids_by_family_and_type(ml_assets: DTO__ml_asset[], type: string, family: string) {
  assert_type_enum(type, ENUM__ml_asset_type);
  assert_type_enum(family, ENUM__ml_asset_family);

  //key - hash_sha256
  let out_ml_asssets_map = new MAP__serializable<string, DTO__ml_asset>();

  for (const ml_asset of ml_assets) {
    if (ml_asset.type != type) continue;
    if (ml_asset.family != family) continue;

    out_ml_asssets_map.set(ml_asset.hash_sha256, ml_asset);
  }

  /*
   *
   */

  let out_ml_asssets_list = out_ml_asssets_map.values();

  out_ml_asssets_list.sort(DTO__ml_asset.sort_by_name_and_version);

  let out = out_ml_asssets_list.map(item => item.hash_sha256);

  return out;
}
